"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const GMOptsContext = react_1.default.createContext(null);
exports.default = GMOptsContext;
//# sourceMappingURL=gmOptsContext.js.map